/**
 * @desc 审核说明
 */
import {
  AbortiveExplainEntity,
  AbortiveExplainForm
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type AuditAbortiveExplainParameter = AbortiveExplainForm

const method = 'POST'
const url = '/trade/abortiveExplain/audit'

export const auditAbortiveExplainApi = (
  data?: AuditAbortiveExplainParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<AbortiveExplainEntity>({
    method,
    url,
    data,
    ...config
  })
}

auditAbortiveExplainApi.method = method
auditAbortiveExplainApi.url = url
